import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { offlineOrdersAccessRoles } from './access';
import { OfflineSalePage } from './pages/OfflineSalePage';

export const offlineOrdersRoutes: RouteObject[] = [
  {
    path: 'offline-orders',
    element: <OfflineSalePage />,
    handle: defineHandle({
      roles: [...offlineOrdersAccessRoles],
      breadcrumb: 'common:nav.offlineSale',
      title: 'common:nav.offlineSale',
    }),
  },
];
